import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { CgPlayStopR } from "react-icons/cg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import LazyMemberImage from "../components/LazyMemberImage";
import ReUsableModal from "../components/ReUsableModal";

const CartScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [foodItemsToList, setFoodItemsToList] = useState([]);
  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });

  const [selectedCategory, setSelectedCategory] = useState("All Items");
  const [itemSizes, setItemSizes] = useState(userInfo?.itemSizes);

  const [showModal, setShowModal] = useState(false);
  const [newOuletItem, setNewOuletItem] = useState();
  const [foodItems, setFoodItems] = useState(
    userInfo?.foodList?.filter((fl) =>
      Object.keys(userInfo?.selectedItems).includes(fl._id)
    )
  );

  const increaseselectedItems = async (item) => {
    await changeItemCount(item, 1);
  };

  const decreaseselectedItems = async (item) => {
    await changeItemCount(item, -1);
  };

  const changeItemCount = async (item, increaseCount) => {
    let selectedItemSizes;
    console.log("item");
    console.log(item);
    selectedItemSizes = item.availableSizes.find(
      (ai) => ai.sizeName === itemSizes[item._id]?.sizeName
    );

    console.log(selectedItemSizes);
    let getItem = selectedItems[item._id];
    const discountAmount =
      (selectedItemSizes.itemPrice * selectedItemSizes.discountPercent) / 100 +
      selectedItemSizes.discountAmount;
    const itemDetails = {
      itemId: item._id,
      itemName: item.itemName,
      itemSize: selectedItemSizes.sizeName,
      selectedQuantity: increaseCount + getItem.selectedQuantity,
      itemOfferPrice: selectedItemSizes.itemPrice - discountAmount,
      discountAmount: discountAmount,
      itemOriginalPrice: selectedItemSizes.itemPrice,
      gstPercent: userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0,
      totalSellingPrice:
        (increaseCount + getItem.selectedQuantity) *
          (selectedItemSizes.itemPrice - discountAmount) +
        ((increaseCount + getItem.selectedQuantity) *
          (selectedItemSizes.itemPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
          100,

      gstTax:
        ((increaseCount + getItem.selectedQuantity) *
          (selectedItemSizes.itemPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
        100,
    };
    if (itemDetails.selectedQuantity < 1) {
      const abb = delete selectedItems[item._id];
      setSelectedItems({ ...selectedItems });
      dispatch(
        setCredentials({
          ...userInfo,
          selectedItems: { ...selectedItems },
        })
      );
    } else {
      setSelectedItems({ ...selectedItems, [item._id]: itemDetails });
      dispatch(
        setCredentials({
          ...userInfo,
          selectedItems: { ...selectedItems, [item._id]: itemDetails },
        })
      );
    }
    setFoodItems(
      userInfo?.foodList?.filter((fl) =>
        Object.keys(selectedItems).includes(fl._id)
      )
    );
  };

  const handleContinueButton = () => {
    dispatch(setCredentials({ ...userInfo, selectedItems: selectedItems }));
    navigate("/bookingSummary");
  };

  const handleSelectSize = async ({ itemId, sizes }) => {
    setItemSizes({ ...itemSizes, [itemId]: sizes });
    if (!Object.keys(selectedItems).includes(itemId)) return;
    setSelectedItems({
      ...selectedItems,
      [itemId]: {
        ...selectedItems[itemId],
        itemSize: sizes?.sizeName,
        discountAmount:
          (sizes.itemPrice * sizes.discountPercent) / 100 +
          sizes.discountAmount,
        itemOfferPrice:
          sizes.itemPrice -
          ((sizes.itemPrice * sizes.discountPercent) / 100 +
            sizes.discountAmount),
        itemOriginalPrice: sizes.itemPrice,
        totalSellingPrice:
          selectedItems[itemId].selectedQuantity *
          (sizes.itemPrice -
            ((sizes.itemPrice * sizes.discountPercent) / 100 +
              sizes.discountAmount) +
            ((sizes.itemPrice -
              (sizes.itemPrice * sizes.discountPercent) / 100 +
              sizes.discountAmount) *
              (userInfo?.outletsDetails[0]?.separateGst
                ? selectedItems[itemId]?.gstPercent
                : 0)) /
              100),

        gstTax:
          selectedItems[itemId].selectedQuantity *
          (((sizes.itemPrice -
            (sizes.itemPrice * sizes.discountPercent) / 100 +
            sizes.discountAmount) *
            (userInfo?.outletsDetails[0]?.separateGst
              ? selectedItems[itemId]?.gstPercent
              : 0)) /
            100),
      },
    });
    dispatch(
      setCredentials({
        ...userInfo,
        selectedItems: {
          ...selectedItems,
          [itemId]: {
            ...selectedItems[itemId],
            itemSize: sizes.sizeName,
            discountAmount:
              (sizes.itemPrice * sizes.discountPercent) / 100 +
              sizes.discountAmount,
            itemOfferPrice:
              sizes.itemPrice -
              ((sizes.itemPrice * sizes.discountPercent) / 100 +
                sizes.discountAmount),
            itemOriginalPrice: sizes.itemPrice,
            totalSellingPrice:
              selectedItems[itemId].selectedQuantity *
              (sizes.itemPrice -
                ((sizes.itemPrice * sizes.discountPercent) / 100 +
                  sizes.discountAmount) +
                ((sizes.itemPrice -
                  (sizes.itemPrice * sizes.discountPercent) / 100 +
                  sizes.discountAmount) *
                  (userInfo?.outletsDetails[0]?.separateGst
                    ? selectedItems[itemId]?.gstPercent
                    : 0)) /
                  100),

            gstTax:
              selectedItems[itemId].selectedQuantity *
              (((sizes.itemPrice -
                (sizes.itemPrice * sizes.discountPercent) / 100 +
                sizes.discountAmount) *
                (userInfo?.outletsDetails[0]?.separateGst
                  ? selectedItems[itemId]?.gstPercent
                  : 0)) /
                100),
          },
        },
      })
    );
  };

  return (
    <>
      Cart Items
      <div
        style={{
          height: "62vh",
          overflowY: "auto",
          padding: "0rem 0.5rem",
        }}
      >
        {" "}
        <hr />
        {foodItems?.length === 0 && (
          <h5 style={{ color: "red" }}>Your Cart is Empty</h5>
        )}
        {foodItems?.map((ff) => (
          <>
            <Row
              key={ff._id}
              className="align-items-center mb-3"
              style={{
                borderBottom: "1px solid #ddd",
                paddingBottom: "0.8rem",
              }}
            >
              {/* Food Image */}
              <Col xs={3}>
                <LazyMemberImage
                  foodItemId={ff._id}
                  imageUpdatedTimeFromDB={ff.imageUploadedTime}
                  currentlySelling={ff.currentlySelling}
                  photoUploaded={ff.imageUploaded}
                />
              </Col>
              {/* Name & Price */}
              <Col xs={5}>
                <div style={{ fontWeight: "bold" }}>
                  {ff.itemName}{" "}
                  {ff.isVeg ? (
                    <CgPlayStopR style={{ color: "green", width: "0.6rem" }} />
                  ) : (
                    <CgPlayStopR style={{ color: "red", width: "0.6rem" }} />
                  )}
                </div>
                <div style={{ color: "gray", fontSize: "0.9rem" }}>
                  {ff.localName}
                </div>
                <br />
                <span style={{ marginTop: "0.1rem", fontWeight: "500" }}>
                  {(ff.availableSizes.find(
                    (ai) => ai.sizeName === itemSizes[ff._id]?.sizeName
                  )?.discountPercent > 0 ||
                    ff.availableSizes.find(
                      (ai) => ai.sizeName === itemSizes[ff._id]?.sizeName
                    )?.discountAmount > 0) && (
                    <span
                      style={{
                        textDecoration: "line-through",
                        marginRight: "0.2rem",
                      }}
                    >
                      ₹
                      {
                        ff.availableSizes.find(
                          (ai) => ai.sizeName === itemSizes[ff._id]?.sizeName
                        )?.itemPrice
                      }
                    </span>
                  )}
                  <span>
                    ₹
                    {ff.availableSizes.find(
                      (ai) => ai.sizeName === selectedItems[ff._id]?.itemSize
                    )?.itemPrice -
                      (ff.availableSizes.find(
                        (ai) => ai.sizeName === selectedItems[ff._id]?.itemSize
                      )?.itemPrice *
                        ff.availableSizes.find(
                          (ai) =>
                            ai.sizeName === selectedItems[ff._id]?.itemSize
                        )?.discountPercent) /
                        100 -
                      ff.availableSizes.find(
                        (ai) => ai.sizeName === selectedItems[ff._id]?.itemSize
                      )?.discountAmount}
                  </span>{" "}
                  {/* {ff.availableSizes?.length > 1 && (
                        <small
                          href=""
                          onClick={(e) => handleClickSize(ff)}
                          style={{
                            color: "green",
                            textDecoration: "underline",
                          }}
                        >
                          {
                            itemSizes[Object.keys(itemSizes).find((key) => key)]
                            // Object.keys(itemSizes).find((key) => 1)
                          }
                        </small>
                      )} */}
                  {ff.itemQuantity <
                    ff.availableSizes.find(
                      (ai) => ai.sizeName === itemSizes[ff._id]?.sizeName
                    )?.consumptionQty *
                      10 &&
                    ff.itemQuantity > 0 && (
                      <small style={{ color: "red" }}>
                        only{" "}
                        {Math.floor(
                          ff.itemQuantity /
                            ff.availableSizes.find(
                              (ai) =>
                                ai.sizeName === itemSizes[ff._id]?.sizeName
                            )?.consumptionQty
                        )}{" "}
                        left
                      </small>
                    )}
                </span>{" "}
              </Col>
              {/* Quantity Controls */}
              <Col
                xs={4}
                className="d-flex align-items-center justify-content-end"
              >
                {selectedItems[ff._id]?.selectedQuantity > 0 && (
                  <div
                    className="d-flex align-items-center"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "0.5rem",
                      padding: "0.2rem 0.5rem",
                      color: "white",
                      fontSize: "1.1rem",
                      backgroundColor: "rgb(17, 93, 102)",
                    }}
                  >
                    <span
                      style={{ margin: "0.3rem 0.6rem", fontSize: "1.6rem" }}
                      onClick={() => decreaseselectedItems(ff)}
                    >
                      <strong>-</strong>
                    </span>
                    <span style={{ margin: "0 0.5rem" }}>
                      <strong>{selectedItems[ff._id]?.selectedQuantity}</strong>
                    </span>
                    <span
                      style={{ margin: "0.3rem 0.6rem", fontSize: "1.6rem" }}
                      onClick={() =>
                        selectedItems[ff._id].selectedQuantity <
                          ff.itemQuantity && increaseselectedItems(ff)
                      }
                    >
                      <strong>+</strong>
                    </span>
                  </div>
                )}
              </Col>
              {ff.availableSizes?.length > 1 && (
                // <div>
                //   {ff.availableSizes?.map((ai) => (
                //     <li>{ai.sizeName}</li>
                //   ))}
                // </div>

                <div className="vertical-radio-group">
                  {ff.availableSizes?.map((option) => (
                    <Form.Check
                      style={{ margin: "0.8rem 5rem" }}
                      key={option.sizeName}
                      type="radio"
                      label={
                        <span style={{ color: "rgb(17, 93, 102)" }}>
                          {option.sizeName} - {option.sizeDescription} - ₹{" "}
                          {option?.itemPrice -
                            (option?.itemPrice * option?.discountPercent || 0) /
                              100 -
                            (option?.discountAmount || 0)}{" "}
                        </span>
                      }
                      name={`platRadio-${ff._id}${option.sizeName}`}
                      id={`platRadio-${ff._id}${option.sizeName}`}
                      value={option.sizeName}
                      checked={
                        selectedItems[ff._id]?.itemSize === option.sizeName
                      }
                      onChange={(e) =>
                        handleSelectSize({
                          itemId: ff._id,
                          sizes: option,
                        })
                      }
                    />
                  ))}
                </div>
              )}
            </Row>
          </>
        ))}
      </div>
      <hr />
      <Row className="align-items-center">
        <Col>
          <span style={{ color: "rgb(17, 93, 102)" }}>Food Items</span>
          <br />
          <br />
          <strong style={{ fontSize: "1.2rem" }}>
            Total ₹
            {selectedItems &&
              Object.values(selectedItems)
                ?.reduce(
                  (total, it) =>
                    total + Number(it.itemOfferPrice) * it.selectedQuantity,
                  0
                )
                .toFixed(2)}{" "}
            |{" "}
            {selectedItems &&
              Object.values(selectedItems)?.reduce(
                (total, it) => total + Number(it.selectedQuantity),
                0
              )}{" "}
            Items{" "}
          </strong>{" "}
        </Col>
        <Col xs="auto">
          <Button
            disabled={selectedItems && Object.values(selectedItems)?.length < 1}
            style={{
              fontSize: "1rem",
              padding: "0.8rem",
              backgroundColor: "rgb(47, 177, 197)",
              color: "black",
            }}
            className="continue-btn"
            onClick={(e) => handleContinueButton()}
          >
            <strong>CONTINUE</strong>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CartScreen;
